module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};



//////////////////
// WEBPACK FOOTER
// /~/babel-polyfill/~/core-js/modules/_perform.js
// module id = 259
// module chunks = 31